// Axios
import axios from "axios";

// Types
import {
    IMedia,
    IMediaRating,
    IMemberPlan,
    TrialInfo
} from "../types";

class MediaService {

    async getAllMedia(
        clientId: string,
        fetchByDate: string,
        bypassCache = false
    ): Promise<IMedia[]> {
        const params: Record<string, string> = { fetchByDate };
        if (bypassCache) params.bypassCache = "true";
        const response = await axios.get(
            `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/media-items/${clientId}`,
            { params }
        );
        return response.data.data;
    }

    async getAllMediaRatings(sessionToken: string): Promise<IMediaRating[]> {
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: sessionToken ?? "",
            }
        };
        const response = await axios.get(
            `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/rating`,
            { ...config }
        );

        return response.data.data;
    }

    async addMediaRating(sessionToken: string, mediaId: string, rating: number) {
        const reqBody = {
            mediaId: mediaId,
            rating: rating
        };
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: sessionToken ?? "",
            }
        };

        const response = await axios.post(
            `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/rating`,
            { ...reqBody },
            { ...config }
        );

        return response.data.data;
    }

    async getCustomerPurchasedPlans(
        sessionToken: string
    ): Promise<IMemberPlan[]> {
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: sessionToken ?? "",
            },
        };
        const response = await axios.get(
            `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/purchased-plans`,
            { ...config }
        );

        return response.data.data;
    }

    async checkTrialCodeUser(sessionToken: string): Promise<TrialInfo[]> {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/freetrial-plans`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: sessionToken,
                    },
                    validateStatus: (status) => status < 500
                }

            );

            if (response.status >= 400) {
                return [];
            }

            return response.data.data;
        } catch (error: any) {
            return [];
        }
    }
}

export const mediaService = new MediaService();
